function isWebdriverCookieSet() {
    return /(?:^|;\s*)webdriver=/.test(document.cookie);
}

export function returnFalseIfRunningViaAutomation() {
    const isInMemoryProvider = process.env.REACT_APP_FLAG_PROVIDER === "in-memory";
    const isAutomated = navigator?.webdriver || isWebdriverCookieSet();
    const isNavigatorWebdriver = navigator?.webdriver;

    if (isInMemoryProvider) {
        return isAutomated ? "false" : "true";
    } else {
        return isNavigatorWebdriver ? "false" : "true";
    }
}